
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-51aa5d2c\",\"scoped\":false,\"hasInlineConfig\":false}!sass-loader!./declarationsSalarie.scss")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!ts-loader!./declarationsSalarie.ts"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-51aa5d2c\"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./declarationsSalarie.vue.html"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/ficheSalarie/declarations/declarationsSalarie.vue.html
// module id = t0Cb
// module chunks = 2